<template>
	<div class="manageUsers">
		<div class="wrapper">
			<div class="search-input">
				<b-form-input
					class="input-search"
					:placeholder="$t('userDashboard.messages.search')"
					v-model="search"
				></b-form-input>
				<MagnifyIcon class="icon-search" />
			</div>
			<div class="date-pickers" style="margin-right:10px">
				<datepicker
					class="date-input"
					:language="th"
					v-model="searchParams.dateFrom"
				></datepicker>
				<div class="text">{{ $t('paymentHistory.to') }}</div>
				<datepicker
					class="date-input"
					:language="th"
					v-model="searchParams.dateTo"
				></datepicker>
			</div>
			<b-dropdown class="input-choose" no-flip>
				<template v-slot:button-content>
					<span>
						{{
							sortByItem ? sortByItem.text : $t('manageUser.startDateMember')
						}}
						<ChevronDownIcon />
					</span>
				</template>
				<b-dropdown-item
					@click="hanldeSortBy(data)"
					v-for="(data, index) in sortBy"
					:key="index"
					>{{ data.text }}</b-dropdown-item
				>
				<!-- <b-dropdown-item>2</b-dropdown-item> -->
			</b-dropdown>
			<div class="wrap-btn-search">
				<b-button id="fetchUser" @click="fetchUser()" class="btn-search">{{
					$t('manageUser.search')
				}}</b-button>
			</div>
		</div>
		<div class="wrap-list-user">
			<b-table
				hover
				:fields="fields"
				:items="userData"
				thead-class="hidden_header"
			>
				<template v-slot:cell(avatar)="data">
					<b-avatar
						:size="44"
						class="bg-transparent"
						v-bind:class="{
							active:
								data.item.status == 1 &&
								data.item.is_deleted == 0 &&
								data.item.is_suspended == 0,
							'not-active':
								data.item.status == 1 &&
								data.item.is_deleted == 0 &&
								data.item.is_suspended == 1,
							delete:
								data.item.status == 1 &&
								data.item.is_deleted == 1 &&
								data.item.is_suspended == 0
						}"
						:src="
							data.item && data.item.profile_image
								? data.item.profile_image
								: '/images/avatar.png'
						"
					></b-avatar>
				</template>
				<template v-slot:cell(name)="data">
					<div class="title">
						<router-link
							id="sellerDetail"
							:event="data.item ? 'click' : ''"
							class="sellar-div"
							:class="data.item ? null : 'no-pointer'"
							:to="$i18nRoute({ name: 'seller-detail' }, data.item.id)"
							style="color: var(--projectPrimaryColor) !important;"
						>
							{{ data.item.name }}
						</router-link>
					</div>
					<a class="email" :href="'mailto:' + data.item.email">{{
						data.item.email
					}}</a>
				</template>
				<template v-slot:cell(memberSince)="data">
					<div class="title">
						{{ $t('manageUser.memberSince') }}
					</div>
					<div class="text">
						{{ formatDate(data.item.created_at) }}
					</div>
				</template>
				<template v-slot:cell(lastLogin)="data">
					<div class="title">{{ $t('manageUser.lastLogin') }}</div>
					<div class="text">
						{{
							data.item.last_time_active && data.item
								? formatDate(data.item.last_time_active)
								: ''
						}}
					</div>
				</template>
				<template v-slot:cell(listings)="data">
					<div class="title">
						{{ $t('manageUser.alllistings') }}
					</div>
					<div class="text listing-number">
						<b-button @click="showListingNumber(data.item.id)" class="show-listing-number">{{$t('Total Listing')}}</b-button>
						<!-- {{ data.item.total_listings }} -->
					</div>
				</template>
				<template v-slot:cell(tooltip)="data">
					<span
						@click="showModal(data.item)"
						v-if="data.item.is_deleted == 0 && currentUser.id !== data.item.id"
					>
						<EditIcon style="stroke:var(--projectPrimaryColor)" />
					</span>
					<!-- <span @click="showModalListEmail(data.item)">
                          <EmailIcon />
                        </span> -->
					<span
						@click="deleteUser(data.item)"
						v-if="data.item.is_deleted == 0 && currentUser.id !== data.item.id"
					>
						<TrashIcon />
					</span>
				</template>
			</b-table>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results"
					><b-alert show variant="light" v-if="!items.length">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert></span
				>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
		<b-modal
			id="modal-admin-update-user-profile"
			centered
			hide-footer
			hide-header
		>
			<div class="content-admin-profile">
				<div class="wrap-content">
					<div class="content-body">
						<div class="form-div">
							<div class="form-group">
								<label>
									{{ $t('member status') }}
								</label>
								<b-dropdown class="input-choose" no-flip>
									<template v-slot:button-content>
										<span>
											{{ statusItem ? statusItem.text : '' }}
											<ChevronDownIcon />
										</span>
									</template>
									<b-dropdown-item
										@click="hanldeStatus(data)"
										v-for="(data, index) in userStatus"
										:key="index"
										>{{ data.text }}</b-dropdown-item
									>
									<!-- <b-dropdown-item>2</b-dropdown-item> -->
								</b-dropdown>
							</div>
						</div>
						<div class="button-div">
							<b-button
								id="hideModalProfileUser"
								@click="hideModalProfileUser"
								class="btn-submit-info reject-button"
								>{{ $t('cancel') }}</b-button
							>
							<b-button
								@click="completeProfile"
								type="submit"
								class="btn-submit-search"
								id="completeProfile"
								>{{ $t('record') }}</b-button
							>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="modal-list-email" centered hide-footer hide-header>
			<div class="mb-1">
				<div class="title">{{$t('Email Receiving Status')}} %Username%</div>
				<div class="wrapper">
					<b-list-group>
						<b-list-group-item>
							<div class="name-email">Email Name 1</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 2</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email unsent">Email Name 1</div>
							<b-button class="btn-send-email">
								<SendIcon />
								{{$t('send email')}}
							</b-button>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 3</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 4</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 5</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 6</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 7</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 8</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email unsent">Email Name 9</div>
							<b-button class="btn-send-email">
								<SendIcon />
								{{$t('send email')}}
							</b-button>
						</b-list-group-item>
						<b-list-group-item>
							<div class="name-email">Email Name 10</div>
							<div class="sent-success">{{$t('Email received')}}</div>
						</b-list-group-item>
					</b-list-group>
				</div>
				<div class="wrap-btn-close">
					<b-button class="btn-close" @click="hideModal('modal-list-email')"
						>{{$t('close')}}</b-button
					>
				</div>
			</div>
		</b-modal>
		<b-modal id="modal-list-number-of-listing" centered hide-footer hide-header style="max-width:800px">
			<div class="mb-1" v-if="userListing">
				<div class="title">Total number of listing for {{userListing.user.display_name}}</div>
				<div class="wrapper">
					<b-row>
						<b-col cols="3">{{$t('Expired listing')}}</b-col>
						<b-col cols="3">{{$t('Rejected Listing')}}</b-col>
						<b-col cols="3">{{$t('Deleted Listing')}}</b-col>
						<b-col cols="3">{{$t('Total Listing')}}</b-col>
					</b-row>
					<b-row>
						<b-col cols="3">{{userListing.user.total_listing_expired}}</b-col>
						<b-col cols="3">{{userListing.user.total_listing_rejected}}</b-col>
						<b-col cols="3">{{userListing.user.total_listing_deleted}}</b-col>
						<b-col cols="3">{{userListing.user.total_listing}}</b-col>
					</b-row>
				</div>
				<b-row align-content="center" class="wrap-btn-close">
					<b-col  class="text-center"><b-button class="btn-close" @click="close()">{{$t('Close')}}</b-button></b-col>
				</b-row>
			</div>
		</b-modal>
	</div>
</template>

<script>
// Icons
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
//import PencilOutlinedIcon from "vue-material-design-icons/PencilOutline.vue";
import EditIcon from '@/components/icons/IconEdit/index';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import TrashIcon from '@/components/icons/IconTrash';
import SendIcon from '@/components/icons/IconSend';
import moment from 'moment';
// import CloseIcon from 'vue-material-design-icons/Close.vue';
// import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';

import InfiniteLoading from 'vue-infinite-loading';

import { mapGetters, mapActions } from 'vuex';
import { Trans } from '@/plugins/Translation';
import {
	required,
	minLength,
	sameAs,
	between,
	email
} from 'vuelidate/lib/validators';

import Datepicker from 'vuejs-datepicker';
import { en, th } from 'vuejs-datepicker/dist/locale';

export default {
	components: {
		MagnifyIcon,
		//PencilOutlinedIcon,
		ChevronDownIcon,
		TrashIcon,
		InfiniteLoading,
		// CloseIcon,
		// EmailIcon,
		SendIcon,
		EditIcon,
		Datepicker
	},
	data() {
		return {
			userListing:null,
			en: en,
			th: th,
			fields: [
				'avatar',
				'name',
				'memberSince',
				'lastLogin',
				'listings',
				{ key: 'tooltip', tdClass: 'td-tooltip' }
			],
			items: [],
			sortBy: [
				{ text: this.$t('Membership date'), value: 'StartDateMember' },
				{ text: this.$t('name'), value: 'Name' },
				{ text: this.$t('Number of announcements, high-low'), value: 'AmountOfListingHigh' },
				{ text: this.$t('Number of announcements low-high'), value: 'AmountOfListingLow' }
			],
			search: '',
			sortByItem: null,
			searchParams: {
				take: 10,
				page: 1,
				sort_by: 'StartDateMember',
				dateFrom:null,
				dateTo:null
			},
			userStatus: [
				{ id: 1, text: this.$t('userProfile.active') },
				{ id: 2, text: this.$t('userProfile.suspend') }
			],
			statusItem: null,
			userItem: {
				id: '',
				status: 1
			},
			currentUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: {}
		};
	},
	mounted() {
		let date = new Date();
		this.searchParams.dateFrom = new Date(date.setMonth(date.getMonth() - 1));
		this.searchParams.dateTo = new Date();
		this.fetchUser();
	},
	computed: {
		...mapGetters('UserManagerController', ['userData']),
		selectedLanguage(){
			return Trans.currentLanguage
		}
	},
	methods: {
		...mapActions('UserManagerController', [
			'GET_DATA_USER_MANAGER',
			'UPDATE_INFO_USER_ADMIN',
			'DELETE_USER_ADMIN'
		]),
		...mapActions('AdminManagerController', [
			'GET_NUMBER_OF_LISTING_OF_USER'
		]),
		showListingNumber(userId){
			console.log(userId)
			this.GET_NUMBER_OF_LISTING_OF_USER({userId:userId}).then((data)=>{
				console.log("data",data)
				this.userListing=data.data.data
				this.$bvModal.show('modal-list-number-of-listing')
			})
		},
		close(){
			this.$bvModal.hide('modal-list-number-of-listing')
		},
		showModal(item) {
			if (item.is_deleted != 1) {
				this.$bvModal.show('modal-admin-update-user-profile');
				this.userItem.id = item.id;
				this.userItem.status = item.status;

				this.userStatus.map(item => {
					if (item.id == this.userItem.status) {
						return (this.statusItem = item);
					}
				});
			}
		},
		hideModalProfileUser() {
			this.$bvModal.hide('modal-admin-update-user-profile');
		},
		hanldeSortBy(item) {
			this.sortByItem = item;

			this.searchParams.sort_by = item.value;
		},
		fetchUser() {
			let prms = { ...this.searchParams };
			prms.page = 1;
			if(this.search){
				prms.search=this.search;
			}
			this.GET_DATA_USER_MANAGER(prms);
		},
		formatDate(date) {
			var formatTimezone = moment(date).toDate();
			return moment(formatTimezone)
				.locale('th')
				.format('DD MMM YYYY');
		},
		infiniteHandler($state) {
			let prms = { ...this.searchParams };

			prms.page += 1;
			if(this.search){
				prms.search=this.search;
			}

			this.searchParams = prms;

			this.GET_DATA_USER_MANAGER(prms).then(async response => {
				if (response.data.data.length > 0) {
					await $state.loaded();
				} else {
					await $state.complete();
				}
			});
		},
		hanldeStatus(item) {
			this.statusItem = item;
		},
		showModalListEmail(item) {
			if (item.is_deleted != 1) {
				this.$bvModal.show('modal-list-email');
			}
		},
		hideModal(id) {
			this.$bvModal.hide(id);
		},
		deleteUser(item) {
			if (item.is_deleted != 1) {
				this.$swal({
					title: this.$t('you want to delete'),
					text: item.name,
					customClass: {
						container: 'swal-del-item'
					},
					showCancelButton: true,
					cancelButtonColor: '#DC3849',
					confirmButtonColor: 'var(--projectPrimaryColor)',
					confirmButtonText: this.$t('cancel'),
					cancelButtonText: this.$t('delete')
				}).then(result => {
					if (result.dismiss == 'cancel') {
						this.DELETE_USER_ADMIN(item.id).then(result => {
							if (result.data.success) {
								this.fetchUser();
								this.$bvToast.toast(this.$t('User deleted successfully'), {
									title: `Success!`,
									variant: 'primary',
									solid: true
								});
							}
						});
					}
				});
			}
		},
		completeProfile() {
			if (this.userItem.status === this.statusItem.id) {
				this.hideModalProfileUser();
				return;
			}
			this.UPDATE_INFO_USER_ADMIN({
				id: this.userItem.id,
				status: this.statusItem.id
			})
				.then(result => {
					this.hideModalProfileUser();
					if (result.data.success) {
						this.resetLoading();
						// this.fetchUser();

						this.$bvToast.toast(this.$t('User information has been updated successfully'), {
							title: `Success!`,
							variant: 'primary',
							solid: true
						});
					}
				})
				.catch(error => {
					this.fetchUser();
					this.$bvToast.toast(
						this.$t('There are some errors Please try again later'),
						{
							title: `Error!`,
							variant: 'danger',
							solid: true
						}
					);
				});
		},
		resetLoading() {
			this.$store.commit('UserManagerController/UPDATE_EMPTY_DATA');
			this.searchParams.page = 1;
			this.$nextTick(() => {
				this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
			});
		}
	}
};
</script>
<style lang="scss">
@import 'adminManageUsers.scss';
</style>
